import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getDebatePoints } from '../../../../redux/Thunks/debatesThunk';
import { Link } from 'react-router-dom';
import { extractTime } from '../../../common/set_date';


const ChatRoom = ({ debateId }) => {
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([])
  const [connectionStatus, setConnectionStatus] = useState('connecting'); // eslint-disable-line

  // Fetch initial debate points
  useEffect(() => {
    const fetchDebatePoints = async () => {
      const { payload } = await dispatch(getDebatePoints({ debate_id: debateId }));
      setMessages(payload || []);
    };

    fetchDebatePoints();
  }, [debateId, dispatch]);

  // Handle WebSocket connection
  useEffect(() => {
    const unFilteredURL = `wss://${process.env.REACT_APP_SERVER_URL}/ws/debates/${debateId}/`;
    let wsUrl = unFilteredURL.replace("https://", "")

    if(process.env.REACT_APP_ENV === "development"){
      wsUrl = `ws://localhost:8000/ws/debates/${debateId}/`;
    }

    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log('WebSocket Connected');
      setConnectionStatus('connected');
    };

    ws.onmessage = (e) => {

      try {
        const data = JSON.parse(e.data);
        setMessages(prev => [...prev, data])

      } catch (err) {
        console.error('Error parsing message:', err);
      }
    };

    ws.onclose = (e) => {
      console.log('ChatRoom WebSocket Closed', e);
      setConnectionStatus('disconnected');
    };

    ws.onerror = (e) => {
      console.error('ChatRoom WebSocket Error', e);
      setConnectionStatus('error');
    };

    // Cleanup function
    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [debateId]); // Only re-run if debateId changes

  return (
    <div className='p-3 relative h-[80vh] md:min-h-[50vh]
    mb-5 overflow-y-scroll scroll-bar-in-dark'>

    <div className='flex flex-col w-full'>
    {messages && messages.map((message, index) => (

          <div
            key={index}
            className={`flex ${message.side === "supports" ? 'justify-start' : 'justify-end'}`}
          >
    <div key={message?.eid}
            className='my-4 w-3/4 md:w-2/4 xl:w-2/5 p-3 text-white'>
          <div className='flex justify-between space-x-3 mb-2 text-sm'>
            <p><b>{message?.author?.username}</b></p>
            <p className='text-[8px]'>{extractTime(message?.date_created)}</p>
          </div>
            <p key={index} className=''>
              {message?.text}
            </p>
            {message?.media?.map((item, idx) => {
              return (<div key={idx} className='h-[200px]'>
                {item.endsWith('mp4') ?
                (
                <video
                className="w-full h-full object-cover rounded-xl"
                controls>
                <source src={item} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
                )
                :
                (
                <Link to={item} target="_blank">
                  <img
                      src={item}
                      alt={`Media`}
                      className="w-full h-full object-cover rounded-xl"
                  />
                  </Link>
                )
                }
              </div>)
            })}



            </div>
          </div>
        ))}
    </div>

    </div>
  );
};

export default ChatRoom;
